// extracted by mini-css-extract-plugin
export default {"profileTxt":"index_profileTxt_uV50Y"};